import { render, staticRenderFns } from "./ListModule.vue?vue&type=template&id=f85f54ae"
import script from "./ListModule.vue?vue&type=script&lang=js"
export * from "./ListModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports